<template>
  <div class="checkout-builder-text-modal">
    <h5>Selecione um ou dos dois dispositivos:</h5>
    <snow-checkbox-group
      v-model="form.config.display"
      :options="[
        { id: 'mobile', name: 'Versão para celular' },
        { id: 'desktop', name: 'Versão para computador' }
      ]"
    />

    <wysiwyg
      style="overflow: scroll;"
      v-model="form.text"
      :hideModules="['image']"
      ref="wysiwyg"
    />

    <div class="row">
      <div class="col-lg-6">
        <form-group
          v-model="form.config.color"
          color
          label="Cor do texto"
          id="background-color"
          placeholder="Ex.: #000000"
        />
      </div>
      <div class="col-lg-6">
        <form-group
          v-model="form.config['background-color']"
          color
          label="Cor do fundo"
          id="background-color"
          placeholder="Ex.: #000000"
        />
      </div>
    </div>

    <div class="snow-submit-buttons mt-3">
      <snow-button
        size="lg"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        text="Inserir Texto"
        @click="save"
        :disabled="!isValid"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(["text", "config"], {
        ...this.data,
        config: {
          display: ["desktop", "mobile"],
          color: "#000",
          "background-color": "",
          ...this.data.config
        }
      })
    };
  },
  computed: {
    isValid() {
      return this.form.text;
    }
  },
  methods: {
    save() {
      this.$emit("save", { ...this.data, type: "text", ...this.form });
    }
  },
  mounted() {
    const linkInputs = document.querySelectorAll(
      ".vw-btn-link + .dashboard form input"
    );
    linkInputs.forEach(input => {
      input.addEventListener("click", () => {
        input.focus();
      });
    });
  }
};
</script>
<style lang="scss" scoped>
.checkout-builder-text-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .editr--content {
    background: #fff;
  }
  ::v-deep #background-color {
    border-radius: 12px !important;
    border: 0.5px solid var(--dark-10) !important;
  }
}
</style>
